var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.91667 23.5C1.40556 23.5 0.958333 23.3083 0.575 22.925C0.191667 22.5417 0 22.0944 0 21.5833V2.41667C0 1.90556 0.191667 1.45833 0.575 1.075C0.958333 0.691667 1.40556 0.5 1.91667 0.5H11.4681V2.41667H1.91667V21.5833H11.4681V23.5H1.91667ZM17.4417 17.5903L16.0681 16.2167L19.3264 12.9583H7.66667V11.0417H19.2625L16.0042 7.78333L17.3778 6.40972L23 12.0319L17.4417 17.5903Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogout);
export default __webpack_public_path__ + "static/media/menu-logout.18b7232593a09d794e37047af01d5bb3.svg";
export { ForwardRef as ReactComponent };